export const SUPPORT_VIDEOS = {
  assignmentTypes: {
    id: "assignmentTypes",
    title: "Advize Assignments: Assignment Types",
    url: "https://vimeo.com/1105865948?share=copy#t=0",
  },
  assignmentEducatorWalkthrough: {
    id: "assignmentEducatorWalkthrough",
    title: "Advize Assignments: Educator Walkthrough",
    url: "https://vimeo.com/1106268270?share=copy#t=0",
  },
  assignmentExportResults: {
    id: "assignmentExportResults",
    title: "Advize Assignments: Exporting and handling assignment results",
    url: "https://vimeo.com/1106268224?share=copy#t=0",
  },
  assignmentStudentExperience: {
    id: "assignmentStudentExperience",
    title: "Advize Assignments: Student Walkthrough",
    url: "https://vimeo.com/1106268176?share=copy#t=0",
  },
};
